import nb from './translations/nb.json'
import en from './translations/en.json'
import ru from './translations/ru.json'
import lv from './translations/lv.json'
import ro from './translations/ro.json'
import pl from './translations/pl.json'

const messages = {
  nb,
  en,
  ru,
  lv,
  ro,
  pl,
  'nb-NO': nb,
  'nn-NO': nb,
  'en-GB': en,
  'en-US': en,
  'ru-RU': ru,
  'lv-LV': lv,
  'ro-RO': ro,
  'pl-PL': pl,
}

type MessagesKey = keyof typeof messages
type TranslationKey = keyof (typeof messages)[MessagesKey]

export default messages as {
  [key in MessagesKey]: {
    [key in TranslationKey]: string
  }
}
